<nb-card class="container">
  <nb-card-header>{{ threeDAssetName }}</nb-card-header>
  <nb-card-body
    class="card-body"
    [nbSpinner]="isLoading"
    nbSpinnerStatus="success"
  >
    <div class="row iframe_container" #iframe_container>
      <div class="model-viewer">
        <canvas #xBimViewer class="idxBimViewer"></canvas>
      </div>
      <div class="model-tools">
        <select class="cmbSelection form-control">
          <option value="noAction" i18n="@@3d-no-action">No action</option>
          <option value="select" i18n="@@3d-select">Select</option>
          <option value="hide" i18n="@@3d-hide">Hide</option>
        </select>
        <button
          class="btn btn-default overlay-button"
          (click)="resetViewerState()"
          i18n="@@3d-reset-button"
        >
          Reset State
        </button>
        <div class="overlay-info">{{ selectedXBimModelID }}</div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="float-right">
      <button
        nbButton
        status="primary"
        ng-reflect-set-status="primary"
        class="btn-primary btn-outline btn-small"
        (click)="close()"
        i18n="@@3d-close-button"
      >
        Close
      </button>
    </div>
  </nb-card-footer>
</nb-card>
